import Vue from 'vue';
import Router from 'vue-router';

import VideoUploader from './components/video-uploader/VideoUploader.vue';
import VideoPicker from './components/video-picker/VideoPicker.vue';
import Divider from './components/divider/Divider.vue';
import SupportedStoryTypes from './components/supported-story-types/SupportedStoryTypes.vue';
import SyncStatus from './components/sync-status/SyncStatus.vue';
import WelcomeStory from './components/welcome-story/WelcomeStory.vue';
import GroupedTextFields from './components/grouped-text-fields/GroupedTextFields.vue';
import SyncDashboard from './components/sync-dashboard/SyncDashboard.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/video-uploader',
      name: 'video-uploader',
      component: VideoUploader,
    },
    {
      path: '/video-picker',
      name: 'video-picker',
      component: VideoPicker,
    },
    {
      path: '/divider',
      name: 'divider',
      component: Divider,
    },
    {
      path: '/supported-story-types',
      name: 'supported-story-types',
      component: SupportedStoryTypes,
    },
    {
      path: '/sync-status',
      name: 'sync-status',
      component: SyncStatus,
    },
    {
      path: '/sync-dashboard',
      name: 'sync-dashboard',
      component: SyncDashboard,
    },
    {
      path: '/welcome-story',
      name: 'welcome-story',
      component: WelcomeStory,
    },
    {
      path: '/grouped-text-fields',
      name: 'grouped-text-fields',
      component: GroupedTextFields,
    },
  ],
});

export default router;
